import { render, staticRenderFns } from "./EmpresaTabelaInserirContrato.vue?vue&type=template&id=65236640&lang=pug"
import script from "./EmpresaTabelaInserirContrato.vue?vue&type=script&lang=js"
export * from "./EmpresaTabelaInserirContrato.vue?vue&type=script&lang=js"
import style0 from "./EmpresaTabelaInserirContrato.vue?vue&type=style&index=0&id=65236640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports